import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'

import {
    createServiceUser,
    loginService,
    profileService,
    userProfileBasicService,
    updateServiceUser
  } from "./services";

import store from "store";

//get user from localStorage
// const user = JSON.parse(localStorage.getItem('user'))
const user = store.get("user");

const initialState = {
    user: user ? user : null,
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ''

}
//register user
export const register = createAsyncThunk('auth/register', async (user:any, thunkAPI:any) => {
    try {

        const res = await createServiceUser(user)
        if (res?.status === 201) {
            const ress = await loginService({email: user?.email, password: user?.password});
            if (ress?.status === 200) {
                console.log("loginaction", res);
        
                store.set("user", ress?.data);
                
            }
            return ress?.data;
           
        }

       

    } catch (err:any) {
        if (err?.response?.data?.status === 409 && err?.response?.data?.error === "user is arleady exist") {
            console.log(" inside if error-----",err.response);
    
            const res = await loginService({email: user?.email, password: user?.password});
              if (res?.status === 200) {
                console.log("loginaction", res);
        
                store.set("user", res?.data);

                const ress = await updateServiceUser( res?.data?.user?._id, user, res?.data?.token);
                if (ress?.status === 200) {

                  console.log("after update response", ress)
               
                  return res?.data;

                }
              }
          
            }else{
                const message = (err.response && err.response.data && err.response.data.message) || err.message || err.toString()
                return thunkAPI.rejectWithValue(message)
            }
        // const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        // return thunkAPI.rejectWithValue(message)

    }

})
//login user
export const login = createAsyncThunk('auth/login', async (user:any, thunkAPI:any) => {
    try {
        const res = await loginService(user);

        if (res?.status === 200) {
            console.log("loginaction", res);
    
            store.set("user", res?.data);
        }

        return res?.data;

    } catch (error:any) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)

    }

})


//logout
export const logout = createAsyncThunk('auth/logout', async () => {

    store.remove("user");
    

})
export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        reset: (state:any) => {
            state.isLoading = false
            state.isSuccess = false
            state.isError = false
            state.message = ''


        }
    },
    extraReducers: (builder:any) => {
        builder.addCase(register.pending, (state:any) => {
            state.isLoading = true

        })
        .addCase(register.fulfilled, (state:any, action:any) => {
            state.isLoading = false
            state.isSuccess = true
            state.user = action.payload

        })
        .addCase(register.rejected, (state:any, action:any) => {
            state.isLoading = false
            state.isError = true
            state.message = action.payload
            state.user = null


        }).addCase(login.pending, (state:any) => {
            state.isLoading = true

        })
        .addCase(login.fulfilled, (state:any, action:any) => {
            state.isLoading = false
            state.isSuccess = true
            state.user = action.payload

        })
        .addCase(login.rejected, (state:any, action:any) => {
            state.isLoading = false
            state.isError = true
            state.message = action.payload
            state.user = null


        }).addCase(logout.fulfilled, (state:any) => {
            state.user = null

        })
    }
})
export const { reset } =  authSlice.actions
export default authSlice.reducer